import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'folder-users',
  size: 24,
  node: [
    [
      'path',
      {
        d: 'M5.254 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2V9.255',
        key: '1rporr',
      },
    ],
    ['circle', { cx: '13', cy: '15', r: '3', key: 'n2jvxj' }],
    ['path', { d: 'M17 22a4 4 0 0 0-8 0', key: '1q7oy8' }],
    [
      'path',
      {
        d: 'M22 22A4 4 0 0 0 20.24 18.686 1 1 0 0 1 20.1 17.143 3 3 0 0 0 19.5 12.402',
        key: '75th5l',
      },
    ],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name FolderUsers
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNS4yNTQgMjBINGEyIDIgMCAwIDEtMi0yVjVhMiAyIDAgMCAxIDItMmgzLjlhMiAyIDAgMCAxIDEuNjkuOWwuODEgMS4yYTIgMiAwIDAgMCAxLjY3LjlIMjBhMiAyIDAgMCAxIDIgMlY5LjI1NSIgLz4KICA8Y2lyY2xlIGN4PSIxMyIgY3k9IjE1IiByPSIzIiAvPgogIDxwYXRoIGQ9Ik0xNyAyMmE0IDQgMCAwIDAtOCAwIiAvPgogIDxwYXRoIGQ9Ik0yMiAyMkE0IDQgMCAwIDAgMjAuMjQgMTguNjg2IDEgMSAwIDAgMSAyMC4xIDE3LjE0MyAzIDMgMCAwIDAgMTkuNSAxMi40MDIiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/folder-users
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FolderUsers = createLucideIcon(__iconData);

export default FolderUsers;
